module.exports = __webpack_public_path__ + "img/hr-branch-particle-27.2c730990.png";